module.exports = __webpack_public_path__ + "img/rads.2dbe29ac.svg";